// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App'
import { store } from './store/store';
import router from './router/iceverg'
import Notifications from 'vue-notification'
import VueGtag from "vue-gtag";
import './filters';
// store

// import './plugins/styles'
Vue.config.productionTip = false;
Vue.use(Notifications);
// Configuration VueAnalytics
if (process.env.BASE_URL !== "http://api.iceverg.local:8082") {
  // Vue.use(VueAnalytics, {
  //   id: 'UA-156294509-1',
  //   router
  // });
  Vue.use(VueGtag, {
    config: {
      id: "UA-156294509-1"
    },
    includes: [
      {id: "294754666"}
    ]
  }, router);
} else {
  // Vue.use(VueAnalytics, {
  //   id: 'UA-XXXXXXXXX-1',
  //   router
  // });
  Vue.use(VueGtag, {
    config: {
      id: 'UA-XXXXXXXXX-1'
    }
  }, router);
}


// Vue.use(vuetify)
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  vuetify,
  render: h => h(App),
  components: {App},
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/iceverg.main.js